import React from "react";
import Input from "./Input";
import ContactFormatter from "../ContactFormatter/ContactFormatter";

const formatPhoneNumber = (value: string): string => {
  return value.replace(/\D/g, "");
};

type ContactInputPropsType = {
  label?: string;
  error?: boolean;
  helperText?: string;
  type?: string;
  onChangeCb?: (e: string) => void;
  disabled?: boolean;
  value?: string;
  name?: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  size?: "small" | "medium";
  placeholder?: string;
  style?: Record<string, string>;
  textFieldLabel?: string;
  required?: boolean;
  isStarPresent?: boolean;
  onBlur?: (e: any) => void;
  isContactNumber?: boolean;
};

const ContactInput = ({
  name,
  type,
  label,
  textFieldLabel,
  value,
  onChangeCb = () => {},
  size,
  error,
  helperText,
  startIcon,
  endIcon,
  style,
  isStarPresent = false,
  onBlur = (e) => {},
  isContactNumber = false,
}: ContactInputPropsType) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const PhoneNumber = formatPhoneNumber(event.target.value);
    onChangeCb(PhoneNumber);
  };

  return (
    <Input
      onBlur={onBlur}
      name={name}
      type={type}
      textFieldLabel={textFieldLabel}
      label={label}
      value={value}
      onChangeCb={handleChange}
      size={size}
      error={error}
      helperText={helperText}
      startIcon={startIcon}
      endIcon={endIcon}
      style={style}
      isStarPresent={isStarPresent}
      inputComponent={isContactNumber ? ContactFormatter : undefined}
    />
  );
};

export default ContactInput;
